import BaseControl from './../BaseControl';
import FSForms from './../../Form/js/fsForms';
import Immutable from 'Immutable';

var uploadStarted;

/**
 * @author Pavel Homolka
 */
export default class CreateDocumentControl extends BaseControl
{
  /** @type String */
  formId;

  /** @type String */
  changeURL;

  /** @type String */
  jsClass;

  /** @type String */
  userLanguage;

  /** @type String */
  changeItem = null;

  /** @type Immutable::Map*/
  stateList;

  /** @type bool */
  isAjax = false;

  /** @type jQuery */
  form;

  /** @type Object */
  reducer;
  
  /** @type String */
  datetimeFormat;
  
  /** @type String */
  focused;

  /** Construct and init **********************************************************************************************/

  constructor(formId, changeURL, jsClass, stateList, userLanguage, datetimeFormat)
  {
    super();
    this.formId = formId;
    this.changeURL = changeURL;
    this.jsClass = jsClass;
    this.stateList = stateList;
    this.userLanguage = userLanguage;
    this.datetimeFormat = datetimeFormat;
  }

  /**
   * @return void
   */
  init()
  {
    this.form = $(`#${this.formId}`);
    this.form.change(this.onChange.bind(this));
    this.form.submit(this.onSubmit.bind(this));

    readOnlySelectSearch();
    readOnlyDateTime();

    // init state for DateTime pickers
    /*
    var thisForm = this;    
    this.form.find('.fs-dateTime-picker').each(function()
    {    
      var el = $(this);      
      el.on('focusout', thisForm.onDateTimePickerChange.bind(thisForm, el));
    });
    */  
    $(document).on("blur", ".fs-dateTime-picker",this.onChange.bind(this));
    $(document).on("blur", ".fs-date-picker",this.onChange.bind(this));
    $(document).on("blur", ".fs-time-picker",this.onChange.bind(this));
    //$(document).on("blur", ".form-control",this.onChange.bind(this));

    // init bootstrap file input
    
    //var fileInput = this.form.find('input[name="createDocument_newBinnary"]');
    //fileInput.fileinput({ language: this.userLanguage });
    //fileInput.on('fileloaded', this.fileLoaded.bind(this));
    //fileInput.on('fileclear', this.fileClear.bind(this));
    
    var fileInput = this.form.find('input[name="createDocument_newBinnary"]');
    fileInput.on('change', this.fileLoaded.bind(this));
    
    var dropzone_file_remover = this.form.find('.frm-createDocument-insertForm-createDocument_newBinnaryremove');
    dropzone_file_remover.on('click', this.fileClear.bind(this));

    // init bootstrap templates input
    var templateSelect = $('.insertForm-TemplatesModal-select');
    var templateInput = this.form.find('[id*=createDocument_newTemplate]');
    templateSelect.on('click', this.templateChange.bind(this, templateInput));
    
    // create document without file upload (document is in storage)    
    var windowObject = $(window);
    var nameDocuWithoutInsert = this.form.find('input[name="createDocument_newBinnary_name"]');
    if( nameDocuWithoutInsert.length > 0 ) {
      windowObject.on('load', this.fileWithoutInsert.bind(this, nameDocuWithoutInsert));
    }

    // handle for submit button
    $(`#${this.formId}`+' .fileinput-upload-button').off('click').click(this.onSubmitBtnClick.bind(this));

    // create JS reducer
    if(window[this.jsClass] != undefined)
    {
      this.reducer = Object.assign({}, window[this.jsClass]);

      // call Reducer::init
      if(typeof this.reducer.init === 'function')
      {
        this.reducer.init(this, this.stateList);
      }
    }

                
    
    
  }
  

  /** Handles *********************************************************************************************************/

  /**
   * @param jQuery.Event event
   */
  onChange(event)
  {
    var currentStateForEl = this.getCurrentStateForEl($(event.target));            
    // skip onChange for <input type="file">
    if(currentStateForEl.name == 'createDocument_newBinnary' || currentStateForEl.name == 'createDocument_newTemplate')
    {
      return;
    }

    // update state
    var newState = Immutable.Map({
      nameMeta: currentStateForEl.name,
      value: currentStateForEl.value,
      isRequired: currentStateForEl.isRequired,
      isReadOnly: this.stateList.getIn([currentStateForEl.name, 'isReadOnly']),
      metadataDefinitionEntity: this.stateList.getIn([currentStateForEl.name, 'metadataDefinitionEntity'])
    });
    var newStateList = this.stateList.set(currentStateForEl.name, newState);
    this.stateList = newStateList.set('changedItem', currentStateForEl.name);

    // call user reducer and refresh form
    if(this.reducer !== undefined && typeof this.reducer.onChange === 'function')
    {
      var newStateList = this.reducer.onChange(this.stateList);
      if(!this.stateList.equals(newStateList))
      {
        this.stateList = newStateList;
        this.refresh();
      }
    }
    // call server side callback
    if(this.canCallServer())
    {
      this.sendState();
    }
  }

  canSubmitFormTest()
  {
      return true;
  }

  /**
   * @param jQuery.Event event
   */

  onSubmitBtnClick(event)
  {
      if(this.canSubmitFormTest() === true)
      {
          event.preventDefault();
          this.form.trigger('submit');
      }
      else
      {
          event.preventDefault();
      }
  }

  /**
   * @param jQuery.Event event
   */
  onSubmit(event)
  {
      if(!Nette.validateForm(document.getElementById(this.formId)))
      {
          return false;
      }

      if(window.FormData !== undefined) // FormData may not exist for IE.
      {
          this.requestSingle = $.ajax({
              type: 'POST',
              url: this.form.attr('action'),
              canSubmitForm: this.canSubmit,
              data: new FormData(document.getElementById(this.formId)),
              processData: false,  // tell jQuery not to process the data
              contentType: false,   // tell jQuery not to set contentType
              beforeSend: this.onBeforeSend.bind(this),
              success: this.onSuccess.bind(this),
              error: this.onError.bind(this),
              complete: this.onComplete.bind(this),
              xhr: function(xhr){
                  var xhr = $.ajaxSettings.xhr();
                  xhr.upload.onprogress = function(evt){

                      if ((Date.now() - uploadStarted) > 1000){
                          var footer = $('#createDocument').find('.modal-footer');
                          footer.children('.progress-cover').show();

                          if (evt.lengthComputable) {
                              var value = parseInt( (evt.loaded / evt.total * 100), 10);
                              if (value == 100){
                                  footer.find('.progress-text').hide();
                                  footer.find('.progress-info').hide();
                                  footer.find('.progress-text-success').show();
                                  footer.find('.progress-bar').css('width', value+'%');
                              }else{
                                  footer.find('.progress-bar').css('width', value+'%');
                                  footer.find('.progress-bar').css('width', value+'%');
                                  footer.find('.progress-info').text(value+'%');
                              }
                          }
                      }
                  };
                  return xhr;
              }
          });

          event.preventDefault();
      }
      else
      {
          waiter_open('large','.createDocumentControl');
      }
  }

  onDateTimePickerChange(el)
  {
    var val = el.val();
    var name = el.attr('name');
    var isRequired = false;
    var label = $(`label[for='${$(el).attr('id')}']`);
    if(label !== undefined)
    {
      isRequired = label.hasClass('isRequired');
    }

    var currentStateForEl = {name: name, value: val, isRequired: isRequired};
            
    if(currentStateForEl.name == 'createDocument_newBinnary' || currentStateForEl.name == 'createDocument_newTemplate')
    {
      return;
    }

    // update state
    var newState = Immutable.Map({
      nameMeta: currentStateForEl.name,
      value: currentStateForEl.value,
      isRequired: currentStateForEl.isRequired,
      isReadOnly: this.stateList.getIn([currentStateForEl.name, 'isReadOnly']),
      metadataDefinitionEntity: this.stateList.getIn([currentStateForEl.name, 'metadataDefinitionEntity'])
    });
    var newStateList = this.stateList.set(currentStateForEl.name, newState);
    this.stateList = newStateList.set('changedItem', currentStateForEl.name);
    
    // call user reducer and refresh form
    if(this.reducer !== undefined && typeof this.reducer.onChange === 'function')
    {
      var newStateList = this.reducer.onChange(this.stateList);
      if(!this.stateList.equals(newStateList))
      {
        this.stateList = newStateList;
        this.refresh();
      }
    }

    // call server side callback
    if(this.canCallServer())
    {
      this.sendState();
    }      
  }

  /** Send state ******************************************************************************************************/

  /**
   * @return void
   */
  sendState()
  {
    if(!this.isAjax)
    {
      $.ajax({
        method: 'POST',
        url: this.changeURL,
        contentType: 'application/json',
        data: JSON.stringify({stateList: this.stateList.toJS()}),
        beforeSend: this.onBeforeSend.bind(this),
        success: this.onSuccess.bind(this),
        error: this.onError.bind(this),
        complete: this.onComplete.bind(this)
      });
    }
  }

  /**
   * @param jqXHR
   * @param setting
   */
  onBeforeSend()
  {
    this.isAjax = true;
    uploadStarted = Date.now();
    waiter_open('large','.createDocumentControl');

    var footer = $('#createDocument').find('.modal-footer');
    footer.find('.progress-text').show();
    footer.find('.progress-info').show();
    footer.find('.progress-text-success').hide();
  }

  /**
   * @param payload
   * @param textStatus
   * @param jqXHR
   */
  onSuccess(payload)
  {
    waiter_close();
    
    if(document.activeElement !== null)
    {  
      this.focused = document.activeElement.id;
    }
    else
    {  
      this.focused = '';
    }  
    
    if(payload.snippets)
    {
      for (var id in payload.snippets)
      {
        $(`#${id}`).html(payload.snippets[id]);
      }
      FSForms.init();
    }

    if (payload.redirect)
    {
        $('.modal').modal('hide');
        waiter_open('large');
        window.location.href = payload.redirect;
        return false;
    }

    switch (payload.stateList)
    {
      case 'NO_CHANGES':
        break;
      case 'ERROR':
        this.showMessage(payload.msg, 'danger');
        break;
      case 'GUI_FORM_SUBMIT_SUCCESS':
        $(".create-doc-button-close").trigger('click');
        FSGridSnippet.refreshMainGrid();
        $("#flashMessages").empty();
        $("#createDocument .modal-content").empty();
        flashMessageSuccess(payload.msg);
        break;   
      default:
        this.stateList = Immutable.fromJS(payload.stateList);
    }
  }

  /**
   * @param jqXHR
   * @param textStatus
   * @param error
   */
  onError()
  {
    waiter_close();
    this.showMessage('HTTP error', 'danger');
  }

  /**
   * @return void
   */
  onComplete()
  {
    if(this.focused == 'createDocument' || this.focused == '')
    {  
      $(`#${this.getIdByName(this.stateList.get('changedItem'))}`).focus();
    }
    else
    {
      $('#'+this.focused).focus();
      $('#'+this.focused).trigger('chosen:activate');
    }  
    this.isAjax = false;
    $(".chosen_select_search").each(function()
    {
      if ( $(this).is('[readonly]') )
      {
        $(this).chosen().chosenReadonly(true);
      }
    });
    
    readOnlySelectSearch();
    readOnlyDateTime();
  }

  /** File input *********************************************************************************************************/

  /**
   * @param event
   * @param file
   */
  
  
  fileLoaded(event, file)
  {
    var file = this.form.find('input[name="createDocument_newBinnary"]')[0].files[0];
    
    var needRefresh = false;
    
    if(typeof file == "undefined")
    {
      var fileName = '';
    }
    else
    {
      var fileName = file.name;
    }  

    // fill NAME_DOCU
    if(this.stateList.has('NAME_DOCU'))
    {
      var name_docu = this.form.find('input[name="NAME_DOCU"]').val();
      if(name_docu == '')
      {
        this.stateList = this.stateList.setIn(['NAME_DOCU', 'value'], fileName);
        needRefresh = true;
      }
    }

    // fill CREATED_TS_DOCU
    if(this.stateList.has('CREATED_TS_DOCU'))
    {
      switch( this.datetimeFormat )
      {
          case 'm/d/Y H:i:s': this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('MM/DD/YYYY HH:mm:ss')); break;
          case 'm/d/Y H:i': this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('MM/DD/YYYY HH:mm')); break;          
          case 'y-m-d H:i:s': this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YY-MM-DD HH:mm:ss')); break;
          case 'y-m-d H:i': this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YY-MM-DD HH:mm')); break;          
          case 'Y-m-d H:i:s': this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YYYY-MM-DD HH:mm:ss')); break;
          case 'Y-m-d H:i': this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YYYY-MM-DD HH:mm')); break;                    
          case 'Y-m-d G:i:s': this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YYYY-MM-DD HH:mm:ss')); break;
          case 'Y-m-d G:i': this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YYYY-MM-DD HH:mm')); break;          
          case 'j.n.Y H:i:s': this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('D.M.YYYY HH:mm:ss')); break;          
          case 'j.n.Y H:i': this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('D.M.YYYY HH:mm')); break;
          default: this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('DD.MM.YYYY HH:mm:ss'));
      }      
      needRefresh = true;
    }
    
    // refresh
    if(needRefresh)
    {
      this.refresh();
    }
  };

  /**
   * @return void
   */
  fileClear()
  {
    var needRefresh = false;

    // remove NAME_DOCU
    if(this.stateList.has('NAME_DOCU'))
    {
      this.stateList = this.stateList.setIn(['NAME_DOCU', 'value'], '');
      needRefresh = true;
    }

    // fill CREATED_TS_DOCU
    if(this.stateList.has('CREATED_TS_DOCU'))
    {
      this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], '');
      needRefresh = true;
    }

    // refresh
    if(needRefresh)
    {
      this.refresh();
    }
  };

  /**
   * @param event
   * @param file
   */
  templateChange(event, file, tem)
  {
    var needRefresh = false;
    var templateChoose = this.form.find('[id*=createDocument_newTemplate_chosen] .chosen-single');
    var inputFileName = this.form.find(".insertForm-CreateFile .file-caption-name");
    var inputFile = this.form.find('.insertForm-CreateFile .file-input');

    if( templateChoose.text() != '---' )
    {
      //inputFileName.html( templateChoose.html() );
      inputFile.removeClass('file-input-new');

      // fill NAME_DOCU
      if(this.stateList.has('NAME_DOCU'))
      {
        this.stateList = this.stateList.setIn(['NAME_DOCU', 'value'], templateChoose.text());
        needRefresh = true;
      }

      // fill CREATED_TS_DOCU
      if(this.stateList.has('CREATED_TS_DOCU'))
      {
        this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('DD.MM.YYYY HH:mm:ss'));
        needRefresh = true;
      }
    }
  }

  /**
   * @param event
   * @param fileName
   */
  fileWithoutInsert(event)
  {
    var needRefresh = false;
            
    // fill NAME_DOCU
    if(this.stateList.has('NAME_DOCU'))
    {
      var fileNameEl = document.getElementsByName("createDocument_newBinnary_name");
      if( fileNameEl.length > 0 ) {
        var fileName = fileNameEl[0].value;  
      } 
      this.stateList = this.stateList.setIn(['NAME_DOCU', 'value'], fileName);
      needRefresh = true;
    }

    // fill CREATED_TS_DOCU
    if(this.stateList.has('CREATED_TS_DOCU'))
    {
      switch( this.datetimeFormat )
      {
          case 'm/d/Y H:i:s': this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('MM/DD/YYYY HH:mm:ss')); break;
          case 'm/d/Y H:i': this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('MM/DD/YYYY HH:mm')); break;          
          case 'y-m-d H:i:s': this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YY-MM-DD HH:mm:ss')); break;
          case 'y-m-d H:i': this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YY-MM-DD HH:mm')); break;          
          case 'Y-m-d H:i:s': this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YYYY-MM-DD HH:mm:ss')); break;
          case 'Y-m-d H:i': this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YYYY-MM-DD HH:mm')); break;                    
          case 'Y-m-d G:i:s': this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YYYY-MM-DD HH:mm:ss')); break;
          case 'Y-m-d G:i': this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('YYYY-MM-DD HH:mm')); break;          
          case 'j.n.Y H:i:s': this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('D.M.YYYY HH:mm:ss')); break;          
          case 'j.n.Y H:i': this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('D.M.YYYY HH:mm')); break;
          default: this.stateList = this.stateList.setIn(['CREATED_TS_DOCU', 'value'], moment().format('DD.MM.YYYY HH:mm:ss'));
      }      
      needRefresh = true;
    }

    // refresh
    if(needRefresh)
    {
      this.refresh();
    }
  }
  
  /** Helpers *********************************************************************************************************/
  /**
   * Update the form to the current status.
   * @return void
   */
  refresh()
  {
    this.form.find(':input').each((index) =>
    {
      var input = $(this.form[0][index]);
      var label = $(`label[for='${$(input).attr('id')}']`);
      var name = input.attr('name');
      if(name != 'BIN_ID_SFLF_DCOM')   
      {
        if(this.stateList.has(name))
        {
          var isRequired = this.stateList.getIn([name, 'isRequired']);
          var isReadOnly = this.stateList.getIn([name, 'isReadOnly']);
          var value = this.stateList.getIn([name, 'value']);

          if(isReadOnly == true)
          {  
            input.addClass('not-active', true);
          }
          else
          {
            input.removeClass('not-active', true);
          }  

          input.attr('readonly', isReadOnly);
          input.prop('readonly', isReadOnly);
          
          input.val(value);
          if(isRequired)
          {
            label.addClass('isRequired');
          }
          else
          {
            label.removeClass('isRequired');
          }

        }
      }
    });
    readOnlySelectSearch();
    readOnlyDateTime();
  }

  /**
   * @param String msg
   * @param String type
   */
  showMessage(msg, type)
  {
    var alert = `<div class="alert alert-${type} alert-dismissible" role="alert"><button type="button" class="close" data-dismiss="alert"><span>&times;</span></button>${msg}</div>`;
    if($(`#${this.formId} .alert`).length > 0)
    {
      $(`#${this.formId} .alert`).remove();
    }
    $(`#${this.formId}`).prepend(alert);
  }

  /**
   * @returns {boolean}
   */
  canCallServer()
  {
    
    if(this.reducer !== undefined && typeof this.reducer.canCallPHP === 'function')
    {
      return this.reducer.canCallPHP(this.stateList);
    }
    

    if(['ID_STAT_DOCU', 'ID_CLAS_DOCU', 'ID_RANK_DOCU','FILE_MARK_DOCU','ID_CERT_DOCU','ID_SKART_REZIM_DOCU'].indexOf(this.stateList.get('changedItem')) != -1)
    {
      return true;
    }
    

    return false;
  }

  /**
   * @param String name
   * @return String
   */
  getIdByName(name)
  {
    return this.form.find(`:input[name="${name}"]`).attr('id');
  }

  
};




// WEBPACK FOOTER //
// ./client-side/MetadataLogic/CreateDocument/CreateDocumentControl.js